import React, { FC, useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import { Box, CircularProgress, Grid } from '@mui/material';
import { httpRequest } from 'src/services/httpRequest';
import { useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import CustomTable from 'src/ui-component/CustomTable/Index';
import { useDispatch } from 'react-redux';
import { handleError } from 'src/redux-store/slices/errorSlice';
interface Props {
  applicationDetails: any;
}

const MessageHistory: FC<Props> = ({ applicationDetails }) => {
  const dispatch = useDispatch();
  const { applicationID } = applicationDetails || {};
  const { permit } = useParams();
  const [loading, setLoading] = useState<boolean>(false);
  const [messageHistory, setMessageHistory] = useState<any>({
    columns: ['Message', 'Send To', 'Send Date'],
    rows: []
  });

  //Method to get message history
  const handleGetMessageHistory = async () => {
    setLoading(true);
    const response = await httpRequest(
      'GET',
      `/email/message_history?ApplicationID=${applicationID}&PermitID=${permit}`
    );

    if (response.status === 'success') {
      const data = response?.data?.map((item) => {
        const dateStr = item?.SendDate;
        const [year, month, day] = dateStr.split('T')[0].split('-');
        const formattedDate = `${month}/${day}/${year}`;
        return {
          message: item?.Message,
          sendTo: item?.SentTo,
          sendDate: formattedDate
        };
      });
      setMessageHistory({ ...messageHistory, rows: data });
    } else if (response?.type === 'NETWORK_ERROR') {
    } else {
      toast.error(response?.message);
      dispatch(handleError(response?.message));
    }
    setLoading(false);
  };

  //Method to get message history
  useEffect(() => {
    handleGetMessageHistory();
  }, []);

  return (
    <React.Fragment>
      <Grid container gap={2} mt={2} justifyContent={'space-between'}>
        <Grid
          item
          md={6}
          xs={12}
          sm={12}
          display={'flex'}
          alignItems={'center'}
        >
          <Typography variant="h3" fontSize={'22px'} color={'#6E759F'}>
            Message History
          </Typography>
        </Grid>
      </Grid>    
      <Box mt={2}>
        {loading ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: 100
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <>
            {messageHistory?.rows?.length ? (
              <>
                <CustomTable
                  pagination={0}
                  firstColumnLength
                  setSelectedRowData={''}
                  rows={messageHistory?.rows}
                  columns={messageHistory.columns}
                  isSearch={false}
                />
              </>
            ) : (
              <Typography fontSize={14} textAlign={'center'} mt={15}>
                Message history is not available for the specified application.
              </Typography>
            )}
          </>
        )}
      </Box>
    </React.Fragment>
  );
};

export default MessageHistory;
